import { render, staticRenderFns } from "./ProductoLayoutList.vue?vue&type=template&id=32b03b51&scoped=true&"
import script from "./ProductoLayoutList.vue?vue&type=script&lang=js&"
export * from "./ProductoLayoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b03b51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
